import React,{useState}  from 'react'
import {Box,Typography,Container,Button,Menu,MenuItem, CircularProgress, StepContext} from '@mui/material'
import {useTheme,styled } from '@mui/material/styles'
import MoreIcon from '@mui/icons-material/MoreVert'
import {IconButton} from "@mui/material"
import Divider from '@mui/material/Divider';
import {useNavigate} from 'react-router-dom'
import { add_template,add_templates} from "../Redux/templatesSlice";
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Header from '../Components/Header'
import CustomDialog from '../Components/CustomDialog'
import {useSelector, useDispatch} from 'react-redux';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import ItemView from '../Components/ItemView';
import axios from 'axios'
import Snackbar from '@mui/material/Snackbar'
import { CalendarMonth,ArrowDropDownCircleOutlined, CopyAll, EditNote, Groups, Remove, Timelapse, QuestionAnswerTwoTone, StackedLineChartOutlined } from '@mui/icons-material';
import delete_template from '../Redux/reducers/delete_template';
import delete_user from '../Redux/reducers/delete_user';
import ContentView from '../Components/ContentView'
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';
import ReactPlayer from 'react-player'
import ConfirmDialog from '../Components/ConfirmDialog'

const Accordion = styled((props) => (
	<MuiAccordion disableGutters elevation={4} square {...props} />
))(({ theme }) => ({
	'&:not(:last-child)': {
		borderBottom: 0,
	},
	'&:before': {
		display: 'none',
	},
	borderRadius:10,
	background:"black",
	margin:10
}));

const AccordionSummary = styled((props) => (
<MuiAccordionSummary
	expandIcon={<ArrowDropDownCircleOutlined sx={{ fontSize: 30 }} />}
	{...props}
/>
))(({ theme }) => ({
	background:theme.palette.mode === 'dark'? 'black': 'white',
	flexDirection: 'row',
	marginTop:5,
	height:200,
	'& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
		transform: 'rotate(90deg)',
	},
	'& .MuiAccordionSummary-content': {
		marginLeft: theme.spacing(1),
		marginBottom: theme.spacing(1),
	}
}));
	
const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
	padding: theme.spacing(1),
	background:theme.palette.mode === 'dark'? 'black' : 'white',
}));

const ContainerBox = styled(Box, {
})(({ theme}) => ({
transition: theme.transitions.create('width', {
easing: theme.transitions.easing.sharp,
duration: theme.transitions.duration.enteringScreen,
}),
overflowY: 'auto',
overflowX: 'hidden',
'&::-webkit-scrollbar': {
    width: 7,
    backgroundColor: '#100101'
  },
'&::-webkit-scrollbar-thumb': {
    backgroundColor: '#ffffff',
    borderRadius: 5
  },
//   background:"#100101",
  minHeight:100,
  maxHeight:350,
  justifyContent:"center",
  padding:10,
  alignItems:"center",
  marginBottom:20
}),
);

const QuestionBox = styled(Box, {
})(({ theme}) => ({
transition: theme.transitions.create('width', {
easing: theme.transitions.easing.sharp,
duration: theme.transitions.duration.enteringScreen,
}),
overflowY: 'auto',
overflowX: 'hidden',
'&::-webkit-scrollbar': {
    width: 7,
    backgroundColor: '#100101'
  },
'&::-webkit-scrollbar-thumb': {
    backgroundColor: '#ffffff',
    borderRadius: 5
  },
  minHeight:100,
  maxHeight:500,
  justifyContent:"center",
  alignItems:"center",
  marginBottom:10,
  borderRadius:5
}),
)

const TemplateInfo = ()=>{

const theme = useTheme()
const [level, setLevel] = useState("");
const navigate = useNavigate()
const [loading, setLoading] = useState(false);
const [deleting, setDeleting] = useState(false);
const [del, setDel] = useState(false);
const [open, setOpen] = React.useState(false);
const [showModal, setShowModal] = React.useState(false);
const [isNext, setIsNext] = React.useState(false);
const [message, setMessage] = React.useState("");
const user = useSelector(state => state?.auth.user);
const template = useSelector(state => state?.templates.template);
const templates = useSelector(state => state?.templates.templates);
const [users, setUsers] = React.useState(template?.users || []);
const [anchorEl, setAnchorEl] = React.useState(null);
const [showConfirm, setShowConfirm] = React.useState(false);
const [mobileAnchorEl, setMobileAnchorEl] = React.useState(null);
const [expanded, setExpanded] = React.useState(true);
const cameraRef = React.useRef(null);
const dispatch = useDispatch()

const isMenuOpen = Boolean(anchorEl);
const isApiMenuOpen = Boolean(mobileAnchorEl);

const menuId = 'primary-search-account-menu';
const mobileMenuId = 'primary-search-account-menu-mobile';

const handleMobileMenuClose = () => {
setMobileAnchorEl(null);
};

const handleMenuClose = () => {
setAnchorEl(null);
handleMobileMenuClose();
};

const handleMenuOpen = (event) => {
setAnchorEl(event.currentTarget);
};

const handleChange = () => (event, newExpanded) => {
	setExpanded(newExpanded ? true : false);
};


async function handleUserDelete(userData){

try{
	setMessage("You can not delete a user, you just have to duplicate this template")
	setOpen(true)
}catch(err){
	console.log(err)
}

}

const renderMenu = (
	<Menu
		anchorEl={anchorEl}
		anchorOrigin={{
		vertical: 'top',
		horizontal: 'right',
		}}
		id={menuId}
		keepMounted
		transformOrigin={{
		vertical: 'top',
		horizontal: 'right',
		}}
		open={isMenuOpen}
		onClose={handleMenuClose}
	>
	{
		(user?.email === template?.email) && (
			<>
			<MenuItem sx={{width:250,height:40}} 
				onClick={async (e)=>{
					e?.preventDefault()
					if(user?.email === template?.email){
						const data = {
							id:template?.id,
							email:user?.email,
							token:user?.accessToken
						}
						
						await delete_template(data,add_template,add_templates,templates,dispatch,setDeleting,setMessage,setOpen,navigate)
					}else{
						setMessage("You can not delete this template")
						setOpen(true)
					}
					handleMenuClose()
				}}>
					<IconButton
						size="large"
						aria-label="account of current user"
						aria-controls="primary-search-account-menu"
						aria-haspopup="true"
						color="inherit"
						disabled={deleting ? true : false}
						>
						{
							deleting ? <CircularProgress size={18} sx={{color:"black"}}/> : <Remove fontSize="small" sx={{color:"red"}}/>
						}
					</IconButton>
					<p style={{marginLeft:10,fontSize:12}}>Delete</p>
				</MenuItem>
				<MenuItem sx={{width:250,height:40}} 
					onClick={(e)=>{
						e?.preventDefault()
						navigate("/editTemplate")
					}}>
					<IconButton
						size="large"
						aria-label="account of current user"
						aria-controls="primary-search-account-menu"
						aria-haspopup="true"
						color="inherit"
						
						>
						<EditNote sx={{color:"green"}} fontSize="small"/>
					</IconButton>
					<p style={{marginLeft:10,fontSize:12}}>Edit</p>
				</MenuItem>
				</>
				)
			}
	</Menu>
	);
	
const handleSnackbarOpen = ()=>{
	setOpen(true)
}

const handleSnackbarClose = ()=>{
	setOpen(false)
}

const DescriptionText = ({text,limit})=>{
	const displayText = text?.length > limit ? text?.substring(0,limit) + '...' : text;
	return <Typography color="white" ml={1} fontSize={13}> {displayText} </Typography>
  }

	return(
		<Box width="100%">
			<Header title="Create Assessment">
				<Breadcrumbs aria-label="breadcrumb">
					<Link  sx={{fontSize:12,color:"gray"}} underline="hover" color="inherit" href="/dashboard">
						Dashboard
					</Link>
					<Typography  sx={{fontSize:12,color:"gray"}}>Template Info </Typography>
			</Breadcrumbs>			
			</Header>
			<Container>
				<Snackbar 
					anchorOrigin={{
						vertical: 'top',
						horizontal: 'left',
					}} 
					message={message} 
					onClose={handleSnackbarClose} 
					open={open} 
					autoHideDuration={2000}
				/>
				<Box  sx={{borderRadius:5,width:{xs:450,md:"100%"}}}>
					<Box m={1} display="flex" width="95%" flexDirection="row" justifyContent="space-between" alignItems="center">
						<Typography mt={2} ml={2} style={{fontSize:16,fontFamily:"dinofans"}}>
							Template Detail
						</Typography>
						<Box sx={{display:{xs:"block",md:"flex"},flexDirection:{xs:"column",md:"row"},width:"75%",justifyContent:"flex-end",flexWrap:"wrap"}}>
							<Button onClick={(e)=>{
								e?.preventDefault()
								dispatch(add_template(template))
								setShowConfirm(true)
							}} sx={{backgroundColor:"gold",color:"black",fontSize:{xs:10,md:12},height:30,width:100,fontFamily:"dinofans",margin:1}} variant="contained">
								Use
							</Button>
							{
								(template?.visibility === "Public" || user?.email === template?.email) && (
									<Button onClick={(e)=>{
										e?.preventDefault()
										dispatch(add_template(template))
										navigate("/duplicateTemplate")
									}} sx={{backgroundColor:"maroon",color:"#fff",fontSize:{xs:10,md:12},height:30,width:100,fontFamily:"dinofans",margin:1}} variant="contained">
										Duplicate
									</Button>
								)
							}
							<IconButton onClick={()=>{
								setShowModal(true)
							}} sx={{marginLeft:1}}>
								<Typography pr={1} color="white" fontSize={16} >
									{template?.users?.length}
								</Typography>							
								<Groups fontSize='25' style={{color:"gray"}}/>
							</IconButton>
							<IconButton  onClick={handleMenuOpen}>
								<MoreIcon fontSize="small"/>
							</IconButton>
						</Box>
                        {renderMenu}
					</Box>
						<Box display="flex" flexWrap="wrap" justifyContent="space-evenly" m={2} sx={{backgroundColor:"black"}}>
							<Box sx={{margin:1,color:"gray"}}>
								<Typography sx={{fontFamily:"dinofans",mb:1,fontSize:14}}>
									Title
								</Typography>
								<DescriptionText limit={100} text={template?.name} />
							</Box>
							<Box sx={{margin:1,color:"gray"}}>
								<Typography sx={{fontFamily:"dinofans",mb:1,fontSize:14}}>
									Type
								</Typography>
								<DescriptionText limit={100} text={template?.type} />
							</Box>
							<Box sx={{margin:1,color:"gray"}}>
								<Typography sx={{fontFamily:"dinofans",mb:1,fontSize:14}}>
									Level
								</Typography>
								<DescriptionText limit={100} text={template?.level} />
							</Box>
							<Box sx={{margin:1,color:"gray"}}>
								<Typography sx={{fontFamily:"dinofans",mb:1,fontSize:14}}>
									Visibility
								</Typography>
								<DescriptionText limit={100} text={template?.visibility} />
							</Box>
							<Box sx={{display:"flex",flexDirection:"row",justifyContent:"space-evenly",width:"100%",alignContent:"center",mb:1}}>
								<Box sx={{display:"flex",flexDirection:"row",justifyContent:"center",alignItems:"center"}}>
									<IconButton>
										<CalendarMonth style={{color:"gray"}}/>
									</IconButton>
									<Typography color="white" fontSize={14} width={80}>
										{template?.start_date}
									</Typography>
								</Box>
								<Box sx={{display:"flex",flexDirection:"row",justifyContent:"center",alignItems:"center"}}>
									<IconButton>
										<CalendarMonth style={{color:"gray"}}/>
									</IconButton>
									<Typography color="white" fontSize={14} width={40}>
										{template?.start_moment}
									</Typography>
								</Box>
								<Box sx={{display:"flex",flexDirection:"row",justifyContent:"center",alignItems:"center"}}>
									<IconButton>
										<Timelapse style={{color:"gray"}}/>
									</IconButton>
									<Typography color="white" fontSize={14} width={60}>
										{template?.time} min
									</Typography>
								</Box>
							</Box>
							<Box sx={{margin:1,color:"gray",width:{md:"75%"}}}>
								<Typography sx={{fontFamily:"dinofans",mb:1,fontSize:14}}>
									Description
								</Typography>
								<DescriptionText limit={500} text={template?.description} />
							</Box>
						</Box>
						<Box justifyContent="flex-start" alignItems="flex-start" width="100%" m={1} ml={3}>
							<Typography style={{fontSize:15,fontFamily:"dinofans",color:"gold"}}>
								Template Sections
							</Typography>								
						</Box>
						<ContainerBox>
							{
								template?.sections?.map((item,index)=>(
									<Accordion  key={index} sx={{width:{xs:"100%",md:"95%"},borderRadius:5,margin:1,marginBottom:3}} expanded={expanded} onChange={handleChange(true)}>
										<AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
											<Box sx={{height:200}}>
												<Typography mt={1} mb={1} style={{fontSize:11,fontFamily:"dinofans",color:"gold"}}>
													{index+1}. {item?.title}
												</Typography>
												<ContentView title="Description" content={item?.description}/>
												<Box sx={{display:"flex",flexDirection:"row",justifyContent:"space-evenly",width:"100%",alignContent:"center",marginBottom:1}}>
													<Box sx={{display:"flex",flexDirection:"row",justifyContent:"center",alignItems:"center"}}>
														<IconButton>
															<StackedLineChartOutlined style={{color:"gray"}}/>
														</IconButton>
														<Typography color="white" fontSize={12} width={80}>
															{item?.level}
														</Typography>
													</Box>
													<Box sx={{display:"flex",flexDirection:"row",justifyContent:"center",alignItems:"center"}}>
														<IconButton>
															<CalendarMonth style={{color:"gray"}}/>
														</IconButton>
														<Typography color="white" fontSize={12} width={40}>
															{item?.language}
														</Typography>
													</Box>
													<Box sx={{display:"flex",flexDirection:"row",justifyContent:"center",alignItems:"center"}}>
														<IconButton>
															<Timelapse style={{color:"gray"}}/>
														</IconButton>
														<Typography color="white" fontSize={12} width={60}>
															{item?.duration} min
														</Typography>
													</Box>
												</Box>
												<Box sx={{display:"flex",flexDirection:"row",justifyContent:"space-evenly",width:"100%",alignContent:"center",marginBottom:1}}>
													<Box sx={{display:"flex",flexDirection:"row",justifyContent:"center",alignItems:"center"}}>
														<IconButton>
															<CalendarMonth style={{color:"gray"}}/>
														</IconButton>
														<Typography color="white" fontSize={12} width={100}>
															{item?.total_point} points (100%)
														</Typography>
													</Box>
													<Box sx={{display:"flex",flexDirection:"row",justifyContent:"center",alignItems:"center"}}>
														<IconButton>
															<QuestionAnswerTwoTone style={{color:"gray"}}/>
														</IconButton>
														<Typography color="white" fontSize={12} width={100}>
															{item?.total_questions} questions
														</Typography>
													</Box>
												</Box>
											</Box>
										</AccordionSummary>
										<AccordionDetails  sx={{justifyContent:"center",alignItems:"center",ml:1}}>
											{
												item?.questions?.map((itm,index)=>(
													<QuestionBox key={index}>
														<Typography mt={1} m={1} style={{fontSize:12,fontWeight:400,fontFamily:"dinofans",color:"gold"}}>
															{index+1}. Question
														</Typography>
														<Typography mt={1} m={1} style={{fontSize:12,fontWeight:400,fontFamily:"dinofans",color:"gray"}}>
															Question
														</Typography>
														<Typography mt={1} m={1} style={{fontSize:12,fontWeight:400,color:"#fff"}}>
															{itm?.question}
														</Typography>
														{
															itm?.hasImage && (
																<Box sx={{justifyContent:"center",alignItems:"center",width:"100%",marginLeft:5}}>
																	<img resizemode="cover" src={itm?.imageUrl} width={100} height={100} style={{borderRadius:5}}/>
																</Box>
															)
														}
														{
															itm?.hasAudio && (
																<Box sx={{justifyContent:"center",alignItems:"center"}}>
																	<audio
																		src={itm?.audioUrl}
																		controls
																		style={{width:250,height:50}}
																	/>
																</Box>
															)
														}
														{
															itm?.hasVideo && (
																<Box ml={2} width="100%">
																	<video src={itm?.videoUrl} controls style={{width:200,height:150}}/>
																</Box>
															)
														}
														<Typography mt={2} m={1} style={{fontSize:12,fontWeight:400,fontFamily:"dinofans",color:"gray"}}>
															Type of the question
														</Typography>
														<Typography mt={1} m={1} style={{fontSize:12,fontWeight:400,color:"#fff"}}>
															{itm?.question_type}
														</Typography>
														<Typography mt={2} m={1} style={{fontSize:12,fontWeight:400,fontFamily:"dinofans",color:"gray"}}>
															Possible answer
														</Typography>
														<Typography mt={1} m={1} style={{fontSize:12,fontWeight:400,color:"#fff"}}>
															{itm?.responses[0]}
														</Typography>
													</QuestionBox>
												))
											}
										</AccordionDetails>
									</Accordion>
								))
							}
						</ContainerBox>
				</Box>
				<ConfirmDialog title="Assessment notice" content="By clicking to continue, you will create an assessment based on this template" handleClick={()=>{
					navigate("/addParticipant")
				}} visible={showConfirm} setVisible={setShowConfirm}/>
				<CustomDialog visible={showModal} deleting={del} setVisible={setShowModal} handleUserDelete={handleUserDelete} data={users.length > 0 ? users : template?.users}/>
			</Container>
		</Box>
		)
}

export default TemplateInfo